// 成熟度等级映射（文档 5.6 节）：综合得分 D 落在 1-5 连续区间
export const LEVELS = [
  {"level": "L0", "min": 0, "max": 1, "name": "未起步", "feature": "基本无数据贯通能力，仅零星试点或口头/纸质传递"},
  {"level": "L1", "min": 1, "max": 2, "name": "可重复", "feature": "部分能力起步，有文件但未全面执行，系统间靠人工搬运"},
  {"level": "L2", "min": 2, "max": 3, "name": "受管理", "feature": "制度落地、大部分数据电子采集，关键场景初步贯通"},
  {"level": "L3", "min": 3, "max": 4, "name": "稳健", "feature": "全组织统一推行并纳入考核，跨系统数据基本自动流转"},
  {"level": "L4", "min": 4, "max": 5, "name": "量化优化", "feature": "量化度量、可预测可控，数据驱动现场管控"},
  {"level": "L5", "min": 5, "max": 5.01, "name": "引领", "feature": "全面贯通、智能驱动、持续优化并向外输出经验"},
]

// 打分档位：0-5，步长 0.5
// - 1-5 档来自文档附录的连续档位，允许半分（文档 5.3 节：半分表示“接近上一档但未完全达标”）
// - 0 档为补充：文档定级表规定「L0 = D < 1 档」，若最低只能打 1 分则 L0 恒不可达；
//   增设 0 档“未起步（无任何实践）”后，L0 与其语义“仅零星试点或口头/纸质传递”一致
export const SCORE_STEPS = [0, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5]

// 各档位的展示标签
export const SCORE_STEP_LABELS = {
  0: '未起步',
  1: '1 档',
  1.5: '1.5 档',
  2: '2 档',
  2.5: '2.5 档',
  3: '3 档',
  3.5: '3.5 档',
  4: '4 档',
  4.5: '4.5 档',
  5: '5 档'
}

// 短板能力域改进建议（文档 5.7 节：报告须指出制约等级提升的短板能力域及主要缺口）
export const DOMAIN_ADVICE = {
  "strategy": "补齐数据战略与组织保障：发布经决策层审批的数据战略文件与路线图，设立数据治理委员会与专职数据负责人，明确权责矩阵并纳入组织绩效考核。",
  "security": "强化数据安全与合规基线：制定数据安全总方针并完成核心数据 100% 定级，实施差异化防护，建立独立审计职能与年度审计计划，确保发现问题整改闭环。",
  "arch": "完善数据架构与运维能力：建立企业级数据模型与分布规划，建设数据中台/仓库/湖并统一元数据目录，完善链路监控、自动告警、备份恢复与传输加密机制。",
  "quality": "健全数据质量管理闭环：制定并工具固化数据标准，建立完整性、准确性、时效性、一致性指标体系，定期出具质量分析报告并实现缺陷自动清洗留痕。",
  "value": "提升数据应用与价值转化：建设统一 BI 平台与核心看板，推动分析从描述级向诊断、预测级演进，探索数据资产确权入表与 AI 场景闭环决策。",
  "bim": "夯实 BIM 数据贯通专项能力：采用 IFC 标准语义模型并建立统一术语字典，提升跨阶段模型传递完整率与版本追溯能力，建设流程/规则引擎实现触发式自动交付。",
}

// ⚠️ 自评等级（含亚级 L2a/L2b/L3a/L3b）已迁至 selfAssessment.js，
//    此处不再导出（原 SELF_LEVELS 仅含 L0-L5，无法表达亚级）。
